/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/
// Insert any custom theme js here...
//Alert when clicked on  Add to Cart button
(function($) {
	//console.log('Testing...');
	$("form.product-single__form").submit(function(e) {
		//e.preventDefault();
		if (document.querySelector("input.acceptTerms").checked === false) {
			alert("Please accept the terms and conditions!");
			return false;
		}
	});
})(jQuery);


$(document).ready(function() {

});


// 	setTimeout(function() {
// 		var pay_btn = document.querySelector('.shopify-payment-button__button--unbranded');
// 		pay_btn.addEventListener("click", function(e) {
// 			if (document.querySelector("input.acceptTerms").checked === false) {
// 				e.preventDefault();
// 				e.stopPropagation();
// 				//e.stopImmediatePropagation();
// 				alert("Please accept the terms and conditions!");
// 				//return false;
// 			}
// 		}, true);
// 	}, 1000);
	setTimeout(function() {
		var pay_btn = document.querySelector('.shopify-payment-button__button--unbranded');
		pay_btn.addEventListener("click", function(e) {
			if (document.querySelector("input.acceptTerms").checked === false) {
				e.preventDefault();
				e.stopPropagation();
				//e.stopImmediatePropagation();
				alert("Please accept the terms and conditions!");
				//return false;
			}
		}, true);
	}, 2000);




// Custom Fields on Product and Contact page

var arrow_offers = [];
var acc = document.getElementsByClassName("offer");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    /* Toggle between adding and removing the "active" class,
                                to highlight the button that controls the panel */
    //this.classList.toggle("active");


    if( this.checked ){
      //alert( this.value );
      arrow_offers.push( this.value );
      document.getElementById("interest").value = arrow_offers.join(' + ');

    } else {

      let items = arrow_offers;
      let index = items.indexOf( this.value );
      //alert( index );
      let numberOfElementToRemove = 1;
      if (index !== -1) { items.splice(index,numberOfElementToRemove)} 

      document.getElementById("interest").value = items.join(' + ');
    }
  });
}
